<template>
  <div class="hello">
    <!--  <v-btn class="primary ma-4" @click="testLodash">test lodash random</v-btn> -->

    <div>
      <template v-if="isSuperAdmin">
        <div class="my-4 text-center" justify="center">
          <!-- or create a new date from 'now' -->
          <span>{{ new Date() | moment("dddd, Do MMMM YYYY") }}</span>
        </div>
      </template>

      <template v-if="isGroupe">
        <v-card class="my-4">
          <h1>{{ groupeFromUser.nom_groupe }}</h1>

          <v-card-actions>
            <Navigation :elements="GroupeNavigation" />
          </v-card-actions>
        </v-card>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Widget: require("@/components/Widget.vue").default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Fév",
            "Mar",
            "Avr",
            "Mai",
            "Jui",
            "Juil",
            "Aou",
            "Sep",
            "Oct",
            "Nov",
            "Déc",
          ],
        },

        title: {
          text: "Formations 2020",
          align: "center",
          style: {
            fontSize: "20px",
          },
        },
        colors: ["#009933"],
      },

      series: [
        {
          name: "Formations",
          data: [55, 62, 89, 66, 98, 72, 101, 75, 94, 120, 117, 139],
        },
      ],
    };
  },

  created() {
    if (this.isAnimateur) {
      this.$router.push("/animateur");
    } else {
      if (this.isGroupe) {
        this.$router.push("/groupe");
      } else if (this.isOperateur) {
        this.$router.push("/superviseur");
      } else if (this.isSuperviseur) {
        this.$router.push("/superviseur");
      } else if (this.isAdmin) {
        this.$router.push("/admin");
      } else {
        this.$router.push("/");
      }
    }
  },

  methods: {
    testLodash() {
      console.log(this.lodash.random(20));
    },
    testConfirm() {
      this.$confirm("Voulez vous écrire ?").then((res) => {
        if (res) {
          console.log("Cool");
        }
      });
    },
    ...mapActions({
      //setMessaging: "Notifications/setMessaging",
    }),
  },
  computed: {
    ...mapState({
      parametres: (state) => state.Parametres.parametres,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      user: (state) => state.Auth.user,
      isAnimateur: (state) => state.Auth.isAnimateur,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isOperateur: (state) => state.Auth.isOperateur,
      isGroupe: (state) => state.Auth.isGroupe,
      bailleurs: (state) => state.Bailleurs.bailleurs,
      projets: (state) => state.Projets.projets,
      groupeFromUser: (state) => state.Auth.user,
      Mygroupes: (state) => state.Mygroupes.Mygroupes,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      GroupeNavigation: (state) => state.Navigation.GroupeNavigation,
    }),
  },
};
</script>
<style scope>
.chart-wrapper {
  align-items: center;
  justify-content: center;
}
</style>
